import { z } from 'zod'

import { StructuredDataSchemaItem } from '../../dtos/structured-data'
import baseSchemaFields from './base-schema'
import { makeTypeLiteral } from './helpers'

export default z.object({
  ...baseSchemaFields,
  type: makeTypeLiteral('multiselect'),
  enumValues: z
    .array(z.string().trim().min(1, 'Enum value cannot be empty'))
    .min(2, 'At least 2 enum values are required')
    .refine(
      (arr) => {
        const lower = arr.map((v) => v.toLowerCase())
        return lower.length === new Set(lower).size
      },
      { message: 'Enum values must be unique' },
    ),
  defaultValue: z.array(z.string()).nullable(),
})

export const validateMultiselectSchema = {
  fn: (data: StructuredDataSchemaItem) => {
    if (data.type === 'multiselect' && data.defaultValue) {
      if (data.defaultValue === null) return true
      return data.enumValues.some((value) => data.defaultValue?.includes(value))
    }
    return true
  },
  error: {
    message: 'Default value must be one of the enum values',
    path: ['defaultValue'],
  },
}
